import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './Components/App';
import reportWebVitals from './reportWebVitals';
import { appRouter } from './Components/App';
import Context from './Context';
import {Provider} from "react-redux"
//import store from "./Components/utils/store/store"
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
//    <Provider store={store}> 
// {/* <Provider> */}
   <Context>
    <App />
    </Context>
    // </Provider> 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
